import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';
import { SchoolCalendar, SchoolCalendarService, SchoolCalendarPopupService, SchoolCalendarUtilService} from '.';
import { UnavailableDate, UnavailableDateService } from '../unavailable-date';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal } from '../../shared/index';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-school-calendar-dialog',
    templateUrl: './school-calendar-dialog.component.html'
})
export class SchoolCalendarDialogComponent extends AbstractDialogComponent implements OnInit {

    schoolCalendar: SchoolCalendar;
    authorities: any[];
    isSaving: boolean;
    updatePackagesValididity: boolean;

    unavailabledates: UnavailableDate[];

    schools: School[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private schoolCalendarService: SchoolCalendarService,
        private unavailableDateService: UnavailableDateService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['schoolCalendar', 'unavailableDate']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'];
        this.loadUnavailableDates();
        this.loadSchools();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    loadUnavailableDates() {
        if (!this.schoolCalendar.begining || !this.schoolCalendar.ending ) {
            return;
        }

        this.unavailableDateService
            .search({
                query: SchoolCalendarUtilService.getDateRangeQueryForUnavailableDates(this.schoolCalendar.begining
                        , this.schoolCalendar.ending),
                sort: ['begining,asc']
            })
            .subscribe(
                (res: HttpResponse<UnavailableDate[]>) => {
                    this.unavailabledates = res.body;
                    let schoolCalendarHolidaysIds = this.schoolCalendar.unavailableDates.map(ud => ud.id);

                    this.unavailabledates.forEach (ud => {
                        if (schoolCalendarHolidaysIds.indexOf(ud.id) >= 0) {
                            ud.selected = true;
                        }
                    });
                }, (res: HttpErrorResponse) => this.onError(res)
            );
    }

    private beginingChanged(beginigDate: NgbDateStruct) {
        if (!this.schoolCalendar.begining || !this.schoolCalendar.ending) {
            return;
        }

        this.loadUnavailableDates();
    }

    private endingChanged(beginigDate: NgbDateStruct) {
        if (!this.schoolCalendar.begining || !this.schoolCalendar.ending) {
            return;
        }

        this.loadUnavailableDates();
    }

    save() {
        this.isSaving = true;
        this.schoolCalendar.unavailableDates = this.unavailabledates.filter(ud => ud.selected);
        if (this.schoolCalendar.id !== undefined) {
            this.schoolCalendarService.update(this.schoolCalendar, this.updatePackagesValididity)
                .subscribe((res: SchoolCalendar) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.schoolCalendarService.create(this.schoolCalendar, this.updatePackagesValididity)
                .subscribe((res: SchoolCalendar) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: SchoolCalendar) {
        this.eventManager.broadcast({ name: 'schoolCalendarListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackUnavailableDateById(index: number, item: UnavailableDate) {
        return item.id;
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    }
}

@Component({
    selector: 'jhi-school-calendar-popup',
    template: ''
})
export class SchoolCalendarPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private schoolCalendarPopupService: SchoolCalendarPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.schoolCalendarPopupService
                    .open(SchoolCalendarDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.schoolCalendarPopupService
                    .open(SchoolCalendarDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar-dialog.component.ts